// extracted by mini-css-extract-plugin
export var changeIcon = "_66-4";
export var container = "_66-0";
export var divider = "_66-7";
export var externalLinkIcon = "_66-1";
export var green = "_66-5";
export var helpCircleIcon = "_66-3";
export var iconButton = "_66-2";
export var red = "_66-6";